import { useIdentity } from './useIdentity'

export type UsePermissionsResult<T> = {
  data: T | undefined
  isLoading: boolean
}

export function usePermissions<T = string>(): UsePermissionsResult<T> {
  const { data, isLoading } = useIdentity<{ account_type: T }>()
  return { data: data?.account_type ?? undefined, isLoading }
}
